// extracted by mini-css-extract-plugin
export default {"modalClassName":"src-constrains-ModalHOC-css-module__modalClassName--1ODzq"};